'use client';

import { useSearchParams } from 'next/navigation';
import React, { Suspense } from 'react';
import { Brand } from '@/lib/ui/Brand';
import { Timecode } from '@/lib/ui/Timecode';

const RUSHES_PUBLIC_URL = process.env.NEXT_PUBLIC_RUSHES_PUBLIC_URL ?? 'http://localhost:5173';
if (!process.env.NEXT_PUBLIC_RUSHES_PUBLIC_URL && typeof window !== 'undefined') {
  console.warn('[Rushes Meet] NEXT_PUBLIC_RUSHES_PUBLIC_URL is not set — login redirect will use localhost:5173');
}

function validateNextPath(next: string | null): string {
  if (!next) return '/';
  if (next.startsWith('/') && !next.startsWith('//') && !next.includes('://')) {
    return next;
  }
  return '/';
}

function describeError(error: string): string {
  switch (error) {
    case 'invalid_code':
      return 'The sign-in link expired. Try again.';
    case 'missing_code':
      return "The sign-in link isn't valid.";
    default:
      return "Sign-in didn't complete. Try again.";
  }
}

function LoginContent() {
  const searchParams = useSearchParams();
  const next = searchParams?.get('next') ?? null;
  const error = searchParams?.get('error') ?? null;

  const validatedNext = validateNextPath(next);
  const authorizeUrl = `${RUSHES_PUBLIC_URL}/api/v1/meet/authorize?next=${encodeURIComponent(validatedNext)}`;

  return (
    <main className="m-surface m-landing">
      <header className="m-top">
        <Brand href="/" />
      </header>

      <section className="m-hero">
        <h1 className="m-h1">Sign in</h1>
        <p className="m-lede">Use your Rushes account to continue.</p>
        {error && (
          <p className="m-error" role="alert">
            {describeError(error)}
          </p>
        )}
        <a className="m-btn m-btn-primary" href={authorizeUrl}>
          Sign in with Rushes
        </a>
      </section>

      <div className="m-corner">
        <Timecode />
      </div>
    </main>
  );
}

export default function LoginPage() {
  return (
    <Suspense fallback={<main className="m-surface" />}>
      <LoginContent />
    </Suspense>
  );
}
